import { Box, Divider, Grid, Paper, Typography } from '@mui/material'

import ToothGraphic5 from '@/assets/images/Tooth-graphic-5.svg'
import PieChart from '@/components/PieChart'
import { isNullorEmptyArr } from '@/utils'

function OpaquerPDF({ recipe }) {
  if (recipe.provided_input.indication !== 'PFM Crown') {
    return null
  }

  return (
    <Paper
      id="download-page-0"
      elevation={0}
      sx={{
        backgroundColor: '#FFF',
        px: 5,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        flexGrow: 1,
      }}
    >
      <Grid container sx={{ height: '100%' }}>
        {/* Left Side */}
        <Grid item xs={4} sx={{ backgroundColor: 'white' }}>
          <Box
            component="img"
            src={ToothGraphic5}
            alt="Toothimage"
            sx={{ width: '233px', height: '330px' }}
          />
        </Grid>

        {/* Right Side */}
        <Grid
          item
          xs={8}
          container
          alignItems="center"
          sx={{
            backgroundColor: 'white',
            color: 'black',
            flexGrow: 1,
          }}
        >
          {/* Cervical Pie Chart */}
          {isNullorEmptyArr(
            [recipe.internallayer_advice, 'opaquers_cervical'],
            [recipe.internallayer_advice, 'opaquers_ratios_cervical'],
          ) && (
            <Grid item xs={4}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                m={3}
              >
                <Typography
                  variant="h6"
                  component="div"
                  sx={{ color: 'black', fontWeight: 'bold' }}
                >
                  Cervical
                </Typography>
              </Box>
              <PieChart
                labels={recipe.internallayer_advice.opaquers_cervical}
                values={recipe.internallayer_advice.opaquers_ratios_cervical}
              />
            </Grid>
          )}

          {/* Middle Pie Chart */}
          {isNullorEmptyArr(
            [recipe.internallayer_advice, 'opaquers_middle'],
            [recipe.internallayer_advice, 'opaquers_ratios_middle'],
          ) && (
            <Grid item xs={4}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                m={3}
              >
                <Typography
                  variant="h6"
                  component="div"
                  sx={{ color: 'black', fontWeight: 'bold' }}
                >
                  Middle
                </Typography>
              </Box>
              <PieChart
                labels={recipe.internallayer_advice.opaquers_middle}
                values={recipe.internallayer_advice.opaquers_ratios_middle}
              />
            </Grid>
          )}

          {/* Incisal Pie Chart */}
          {isNullorEmptyArr(
            [recipe.internallayer_advice, 'opaquers_incisal'],
            [recipe.internallayer_advice, 'opaquers_ratios_incisal'],
          ) && (
            <Grid item xs={4}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                m={3}
              >
                <Typography
                  variant="h6"
                  component="div"
                  sx={{ color: 'black', fontWeight: 'bold' }}
                >
                  Incisal
                </Typography>
              </Box>
              <PieChart
                labels={recipe.internallayer_advice.opaquers_incisal}
                values={recipe.internallayer_advice.opaquers_ratios_incisal}
              />
            </Grid>
          )}
        </Grid>
      </Grid>

      {/* Divider */}
      <Divider sx={{ backgroundColor: 'black', opacity: 1 }} />
    </Paper>
  )
}

export default OpaquerPDF
